import { render, staticRenderFns } from "./NewActivity.vue?vue&type=template&id=0cfc2850&"
import script from "./NewActivity.vue?vue&type=script&lang=js&"
export * from "./NewActivity.vue?vue&type=script&lang=js&"
import style0 from "./NewActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports